import React, { useState, useEffect, useRef } from 'react';

const TRANSPARENTE_BASE = 'https://customer-assets-4nw71qhi.emergentagent.net/job_4cdae0ca-9c75-4bc0-a101-39471645aaff/artifacts/ucjiyre4_070C11E2-BF49-489D-8B9C-218DA96E9984.jpeg';

const ModelsSeparator = () => {
  const containerRef = useRef(null);
  const [scale, setScale] = useState(1);
  const [opacity, setOpacity] = useState(1);

  useEffect(() => {
    let rafId;
    const animate = () => {
      if (!containerRef.current) { rafId = requestAnimationFrame(animate); return; }
      const container = containerRef.current;
      const containerTop = container.getBoundingClientRect().top + window.scrollY;
      const containerHeight = container.offsetHeight;
      const windowHeight = window.innerHeight;
      const prog = Math.max(0, Math.min(1,
        (window.scrollY - containerTop) / (containerHeight - windowHeight)
      ));
      setScale(1 - prog * 0.85);
      setOpacity(1 - prog);
      rafId = requestAnimationFrame(animate);
    };
    rafId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(rafId);
  }, []);

  return (
    <div
      ref={containerRef}
      data-testid="models-separator"
      style={{ height: '150vh', position: 'relative', background: '#F5F5F7' }}
    >
      <div style={{
        position: 'sticky', top: 0,
        width: '100vw', height: '100vh',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: '#F5F5F7',
      }}>
        <div
          className="product-halo"
          style={{
            width: '100vw', height: '100vh',
            transform: `scale(${scale})`,
            opacity: opacity,
            transformOrigin: 'center center',
            willChange: 'transform, opacity',
          }}
        >
          <img
            src={TRANSPARENTE_BASE}
            alt="ETERNA — Vista transparente"
            style={{
              width: '100%', height: '100%',
              objectFit: 'contain',
              mixBlendMode: 'multiply',
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ModelsSeparator;
